(function() { window.GUID_14ebebd4_bec3_4e98_aa37_80ebce87314a = { getGuid: function() { return "14ebebd4-bec3-4e98-aa37-80ebce87314a"; } }; })();
var CS;
(function (CS) {
    class ColorPicker {
        constructor(input) {
            this.SelectionChange = null;
            this.Input = input;
            this.ColorPickerId = this.Input[0].id;
            this.HiddenColorMap = $('.HiddenColorMap', this.Input);
            this.HiddenColorMapValue = this.HiddenColorMap.val();
            this.CreatePopup();
            this.BeforeChangeValue = "";
            this.Prepare();
        }
        val(colorMap) {
            if (colorMap != null) {
                this.Input.removeClass();
                this.Input.addClass('CSColorPicker');
                if (colorMap == 0) {
                    this.Input.addClass('transparent');
                }
                else {
                    this.Input.addClass('BFC' + colorMap);
                }
                this.Input.val(colorMap);
                this.HiddenColorMap.val(colorMap);
                this.HiddenColorMapValue = colorMap;
                if (this.SelectionChange != null) {
                    this.SelectionChange.call(this);
                }
                this.Input.trigger("CSChange", this);
            }
            else {
                return this.Input.val();
            }
        }
        CreatePopup() {
            var me = this;
            if (me.Popup != null && me.Popup.length > 0) {
                me.Popup.off('click');
            }
            var popupId = "ColorPopup" + me.ColorPickerId;
            var existingPopup = $('#' + popupId);
            if (existingPopup.length > 0) {
                existingPopup.remove();
            }
            var pop = $('<div id="' + popupId + '">');
            var html = "";
            html = '<div class="CSColorPickerPopup">';
            var letter = "A";
            var selectedClass = "";
            for (var i = 1; i < 72; i++) {
                selectedClass = "";
                if (i == this.HiddenColorMapValue) {
                    selectedClass = " SelectedColor";
                }
                html += "<div data-colormap='" + i + "' class='BFC" + i + selectedClass + "'>" + letter + "</div>";
            }
            //const colorOrder: number[] = [
            //    // 1) Noir
            //    2,   // #231F20 (noir)
            //    // 2) Bruns / rouges très foncés (similaires regroupés)
            //    31,  // #610E11 (brun-rouge sombre)
            //    15,  // #891925 (bordeaux)
            //    21,  // #B32E2C (rouge profond)
            //    27,  // #EF423E (rouge vif)
            //    6,   // #F1615E (corail clair)
            //    55,  // #FF6666 (rouge saumon pastel)
            //    64,  // #FF9999 (rose clair)
            //    // 3) Bruns clairs
            //    30,  // #715F26 (brun foncé “kaki”)
            //    38,  // #B55D27 (cuivré / marron-orangé)
            //    37,  // #A99231 (brun doré)
            //    9,   // #BAA97A (beige)
            //    45,  // #B7AAA7 (gris/brun très clair)
            //    54,  // #D8D1CE (gris/beige pâle)
            //    // 4) Oranges
            //    5,   // #F47921 (orange soutenu)
            //    56,  // #FF6633 (orange vif)
            //    65,  // #FF9966 (orange clair/pastel)
            //    24,  // #FEC56F (pêche / orangé pâle)
            //    // 5) Jaunes
            //    4,   // #E8C31E (jaune doré)
            //    49,  // #EAEB87 (jaune pastel)
            //    57,  // #FFFF66 (jaune “acide”)
            //    66,  // #FFFF99 (jaune pastel clair)
            //    // 6) Olive / vert-jaune
            //    13,  // #6E7330 (olive foncé)
            //    44,  // #CBDC44 (vert-lime clair)
            //    // 7) Verts
            //    3,   // #5CBE7C (vert moyen soutenu)
            //    36,  // #41905F (vert légèrement plus froid)
            //    58,  // #66FF66 (vert très vif)
            //    67,  // #CCFFCC (vert pastel)
            //    // 8) Turquoise / aqua
            //    68,  // #66FFCC (aqua vif)
            //    // 9) Teal foncé
            //    19,  // #08778D (turquoise sombre)
            //    10,  // #044A56 (teal très sombre)
            //    // 10) Bleus
            //    25,  // #26A8E0 (bleu moyen)
            //    70,  // #66CCFF (bleu pastel)
            //    26,  // #9AC7DB (bleu clair / “baby blue”)
            //    61,  // #3399FF (bleu classique)
            //    // 11) Mauves / violets
            //    8,   // #8781BD (mauve grisée)
            //    41,  // #44407F (violet-bleu sombre)
            //    53,  // #C7C4E2 (lavande pastel)
            //    62,  // #9966FF (violet vif)
            //    // 12) Magenta / rose violacé
            //    63,  // #FF99FF (rose-lavande pastel)
            //    // 13) Blanc + Transparent
            //    1,   // #FFFFFF (blanc)
            //    0    // transparent
            //];
            //$.each(colorOrder, (z, c) => {
            //    selectedClass = "";
            //    if (c == this.HiddenColorMapValue) {
            //        selectedClass = " SelectedColor";
            //    }
            //    html += "<div data-colormap='" + c + "' class='BFC" + c + selectedClass + "'>" + letter + "</div>";
            //}); 
            if (this.HiddenColorMapValue == 0) {
                selectedClass = " SelectedColor";
            }
            html += "<div data-colormap='0' class='TransparentBlock" + selectedClass + "'>" + letter + "</div>";
            html += "<a data-colormap='0' class='ClearColor'>" + JSRess.ClearColor + "</a>";
            html += "</div>";
            pop.append(html);
            pop.appendTo(CS.body);
            me.Popup = $('.CSColorPickerPopup', pop);
            me.Popup.on('click', function () {
                me.Input.trigger('blur');
            });
        }
        Prepare() {
            var me = this;
            me.Popup.on('mousedown', 'div', function (e) {
                $('.BFC' + me.HiddenColorMapValue, me.Popup).removeClass('SelectedColor');
                $('.TransparentBlock', me.Popup).removeClass('SelectedColor');
                var colorMap = $(e.target).data('colormap');
                $('.BFC' + colorMap, me.Popup).addClass('SelectedColor');
                if (colorMap == "0") {
                    $('.TransparentBlock', me.Popup).addClass('SelectedColor');
                }
                me.val(colorMap);
            });
            me.Popup.on('mousedown', 'a', function (e) {
                $('.TransparentBlock', me.Popup).removeClass('SelectedColor');
                $('.BFC' + me.HiddenColorMapValue, me.Popup).removeClass('SelectedColor');
                var colorMap = $(e.target).data('colormap');
                $('.BFC' + colorMap, me.Popup).addClass('SelectedColor');
                if (colorMap == "0") {
                    $('.TransparentBlock', me.Popup).addClass('SelectedColor');
                }
                me.val(colorMap);
            });
            me.Input.on('click', function (e) {
                me.Popup.css('left', e.clientX + 'px');
                me.Popup.css('top', e.clientY + 'px');
                me.Popup.slideDown(150, function () {
                    var data = {
                        container: me.Popup,
                    };
                    CS.trigger('colorpicker.shown', data);
                });
            }).on('blur', function (e) {
                if (!Menu.preventHideMenu) {
                    me.Popup.slideUp(150, function () { });
                }
            }).on('keydown', function (e) {
                e.preventDefault();
            });
            CompuSport.DOM.body.on('hidecolorpicker', function (e, caller) {
                if (caller == undefined || caller != me) {
                    me.Popup.slideUp(150, function () { });
                }
            });
            CompuSport.DOM.body.off('mousedown.colorpicker');
            CompuSport.DOM.body.on('mousedown.colorpicker', function (e) {
                var clickedPicker = $(e.target).closest('.CSColorPickerPopup');
                if (clickedPicker.length == 0) {
                    CompuSport.DOM.body.trigger('hidecolorpicker');
                }
            });
        }
        RGBToHex(rgb) {
            if (rgb.indexOf('#') > -1) {
                return rgb;
            }
            rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
            function hex(x) {
                return ("0" + parseInt(x, 10).toString(16)).slice(-2);
            }
            return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
        }
    }
    CS.ColorPicker = ColorPicker;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSColorPicker = function () {
        this.each(function () {
            var colorPicker = new CS.ColorPicker($(this));
            //Donne access au autoComplete de n'importe quels scripts.
            eval('document.' + colorPicker.ColorPickerId + '=colorPicker;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.ColorPicker = function (me) {

    this.SelectionChange = null;
    this.val = function (colorMap) {
        if (colorMap != null) {
            this.Input.removeClass();
            this.Input.addClass('CSColorPicker');

            if (colorMap == 0) {
                this.Input.addClass('transparent');
            }
            else
            {
                this.Input.addClass('BFC' + colorMap);
            }

            this.Input.val(colorMap);
            this.HiddenColorMap.val(colorMap);
   
            if (this.SelectionChange != null)
                this.SelectionChange.call(this);

            this.Input.trigger("CSChange", this);
        }
        else {
            return this.Input.val();
        }


    };
    this.Input = me;
    this.ColorPickerId = this.Input[0].id;
    this.HiddenColorMap = $('.HiddenColorMap', this.Input);
    this.CreatePopup();
    this.BeforeChangeValue = "";
    this.Prepare();

};

CS.ColorPicker.prototype = function () {

    var CreatePopup = function () {

        var me = this;

        if (me.Popup != null && me.Popup.length > 0) {
            me.Popup.off('click');
        }

        var popupId = "ColorPopup" + me.ColorPickerId;

        var existingPopup = $('#' + popupId);

        if (existingPopup.length > 0)
        {
            existingPopup.remove();
        }

        var pop = $('<div id="' + popupId + '">');
        var html = "";
        html = '<div class="CSColorPickerPopup">';
        var letter = "A";
 
        for (var i = 1; i < 72; i++) {
            html += "<div data-colormap='" + i + "' class='BFC" + i + "'>" + letter + "</div>";
        }
   
        html += "<div data-colormap='0' class='TransparentBlock'>" + letter + "</div>";

        html += "</div>";

        pop.append(html);

        pop.appendTo($('body'));

        me.Popup = $('.CSColorPickerPopup', pop);

        me.Popup.on('click', function () {
            me.Input.trigger('blur');
        });
    },
    Prepare = function () {
        var me = this;

        me.Popup.on('mousedown', 'div', function (e) {

            var colorMap = $(e.target).data('colormap');

            me.val(colorMap);

        });
        me.Input.on('click', function (e) {
            me.Popup.css('left', e.clientX  + 'px');
            me.Popup.css('top', e.clientY + 'px');

            me.Popup.slideDown(150, function () {
                var data = {
                    container: me.Popup,
                };

                CS.trigger('colorpicker.shown', data);
            });
        }).on('blur', function (e) {
            if (!preventHideMenu) {
                me.Popup.slideUp(150, function () { });
            }
        }).on('keydown', function (e) {
            e.preventDefault();
        });


    },
    RGBToHex = function (rgb) {
        if (rgb.indexOf('#') > -1) {
            return rgb;
        }
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    };

    return {
        Prepare: Prepare,
        CreatePopup: CreatePopup,
        RGBToHex: RGBToHex
    };

}();
*/ 

//# sourceMappingURL=cs.colorpicker.js.map
